import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import getManglik from "../../../../../../_selectors/dataSelectors/getManglik";
import getMoonSign from "../../../../../../_selectors/dataSelectors/getMoonSign";

class AstrologyDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const { manglik, moonSign } = nextProps.userProfile;
      const { selectedManglik, selectedMoonSign, isEditModeOn } = prevState;

      if (isEditModeOn) {
        return null;
      } else {
        if (manglik !== selectedManglik || moonSign !== selectedMoonSign) {
          return {
            selectedManglik: manglik,
            selectedMoonSign: moonSign
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedManglik: null,
    selectedMoonSign: null
  };
  componentDidMount() {
    const { manglik, getManglikData, moonSign, getMoonSignData } = this.props;
    if (manglik.length === 0) {
      getManglikData();
    }
    if (moonSign.length === 0) {
      getMoonSignData();
    }
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const { selectedManglik, selectedMoonSign } = this.state;
    const { update, toast } = this.props;

    const updatedAstrologyDetail = {
      manglik: selectedManglik,
      moonSign: selectedMoonSign
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    update({ data: updatedAstrologyDetail, onSuccess, onError });
  };
  render() {
    const {
      isEditModeOn,
      selectedManglik,
      selectedMoonSign,
      showEdit
    } = this.state;
    const { manglik, moonSign, userProfile } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Astrology Detail
            <EditWidget
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={userProfile.cache}
              show={showEdit}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Manglik</Wrapper>}
                selected={selectedManglik}
                options={manglik}
                onChange={value => {
                  this.setState({ selectedManglik: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Moon Sign</Wrapper>}
                selected={selectedMoonSign}
                options={moonSign}
                onChange={value => {
                  this.setState({ selectedMoonSign: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  manglik: getManglik(state),
  moonSign: getMoonSign(state)
});
const mapDispatchToProps = dispatch => ({
  getManglikData: () => dispatch(dataActions.getHabitType()),
  getMoonSignData: () => dispatch(dataActions.getMoonSign())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AstrologyDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Astrology/AstrologyDetail/index.js